import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyModel } from 'common/models/page-models/internship-company/internship-company/internship-company-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { CompanyFormWidgetService } from 'common/widget/internship-company/comapny-form-widget.service';


@Injectable({
    providedIn: 'root'
})
export class CompanyFormResolver extends FormResolverService<CompanyModel> {
    constructor(
        protected fs: CompanyFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    // override modifyResponseData(dataModel, meta, widget) {
    //     dataModel['internshipCompanyId'] ;
    //     return dataModel;
    // }
}
